import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=8703b2fc&"
import script from "./Question.vue?vue&type=script&lang=ts&"
export * from "./Question.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8703b2fc')) {
      api.createRecord('8703b2fc', component.options)
    } else {
      api.reload('8703b2fc', component.options)
    }
    module.hot.accept("./Question.vue?vue&type=template&id=8703b2fc&", function () {
      api.rerender('8703b2fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/stay-inputs/Question.vue"
export default component.exports